import { FC, PropsWithChildren } from 'react';

import MainLayout from '../../../components/uikit-components/MainLayout/MainLayout';

export const MarkbookLayout: FC<PropsWithChildren> = ({ children }) => {
  return <MainLayout>{children}</MainLayout>;
};
